import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PRODUCT_FILTERS } from 'src/app/helpers/filters.helper';
import { PRODUCT_IMAGES } from 'src/app/helpers/google-storage.helper';
import Utils from 'src/app/helpers/utils.helper';
import { CompanyShoes } from 'src/app/models/company-shoes.model';
import { ShoesFilter } from 'src/app/models/filters/shoe-filter.model';
import { ShoesFilterOptions } from 'src/app/models/filters/shoes-filter-options.model';
import { PagedCollectionResponse } from 'src/app/models/http/page-collection-response.model';
import { SelectedShoe } from 'src/app/models/local-storage/selected-shoe.model';
import { StandardShoeWidths } from 'src/app/models/standard-shoe-widths.model';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { CompanyShoesService } from 'src/app/services/repositories/company-shoes.service';
import { StandardShoeSizesService } from 'src/app/services/repositories/standard-shoe-sizes-service';
import { StandardShoeWWidthsService } from 'src/app/services/repositories/standard-shoe-widths.service';

@Component({
    selector: 'app-safety-shoes',
    templateUrl: './safety-shoes.component.html',
    styleUrls: ['./safety-shoes.component.scss'],
    standalone: false
})
export class SafetyShoesComponent implements OnInit {
  toggleClass: boolean = true;
  shoes: CompanyShoes[] = [];
  sizes: string[] = [];
  brands: string[] = [];
  widths: StandardShoeWidths[] = [];
  filters: ShoesFilter | undefined;
  filterParams: HttpParams = new HttpParams();
  totalItems: number = 0;
  currentPage: number = 1;
  shoesFilterOptions: ShoesFilterOptions = new ShoesFilterOptions();

  constructor(private _loaderService: NgxUiLoaderService,
              private _localStorageService: LocalStorageService,
              private _companyShoesService: CompanyShoesService,
              private _standardShoeSizesService: StandardShoeSizesService,
              private _standardShoeWidthsService: StandardShoeWWidthsService) { }

  ngOnInit(): void {
    this.getSavedFilters();
    this.loadShoes();
  }

  loadShoes() {
    this._loaderService.start();
    this.getFilterParams();
    forkJoin({
      shoes: this._companyShoesService.getShoes(this.filterParams),
      brands: this._companyShoesService.getShoeBrands(this.filterParams),
      widths: this._standardShoeWidthsService.getStandardShoeWidths(),
      sizes: this._standardShoeSizesService.getStandardShoeSizes()
    })
    .pipe(
      finalize(() =>
        this._loaderService.stop())
    )
    .subscribe(({shoes, brands, widths, sizes}) => { 
      this.widths = widths;
      this.brands = brands;
      this.sizes = sizes;
      this.totalItems = shoes.totalResult;
      this.shoes = shoes.items;
      this.shoesFilterOptions = this.buildFiltersObject();      
    }, (error: any) => {
      console.log(error);
    });
  }

  buildFiltersObject() : ShoesFilterOptions {
    const filterOptions = new ShoesFilterOptions();
    filterOptions.genders = PRODUCT_FILTERS.genders.map(g => ({
      value: g,
      text: g,
      isSelected: this.filters?.gender == g? true : false
    }));
    filterOptions.priceRanges = PRODUCT_FILTERS.priceRanges.map(pr => ({
      value: pr,
      text: pr,
      isSelected: this.filters?.priceRange == pr? true : false
    }));
    filterOptions.brands = this.brands.map(b => ({
      value: b,
      text: b,
      isSelected: this.filters?.brands.includes(b)? true : false
    }));
    filterOptions.sizes = this.sizes.map(s => ({
      value: s,
      text: s,
      isSelected: this.filters?.sizes.includes(s)? true : false
    }));
    filterOptions.widths = this.widths.map(w => ({
      value: w.width,
      text: w.widthDisplayText,
      isSelected: this.filters?.widths.includes(w.width)? true : false
    }));
    if (this.filters) {
      filterOptions.page = this.filters.page;
    }
    return filterOptions;
  }

  pageChange(val: number) {
    if (!this.filters) {
      this.filters = new ShoesFilter();
    }
    this.filters.page = val;
    this.filterData(this.filters);
  }

  getSavedFilters() {
    this.filters = this._localStorageService.getProductFilters() as ShoesFilter;
    if (this.filters) {
      this.currentPage = this.filters.page;
    }
  }

  setFilters(filters: ShoesFilter) {
    if (filters) {
      this.filters = filters;
      this._localStorageService.setProductFilters(this.filters);
    }
    else {
      this.filters = new ShoesFilter();
    }
  }

  getFilterParams() {
    this.filterParams = new HttpParams();
    if (this.filters) {
      this.filterParams = Utils.getHttpParams(this.filters, this.filterParams);
    }
  }

  filterData(filters: ShoesFilter) {
    this.setFilters(filters);
    this.loadShoes();
  }

  selectProduct(shoeId: number, style: string) {
    const selectedShoe : SelectedShoe = {
      companyShoeId: shoeId,
      style: style
    }
    this._localStorageService.setSelectedStyle(selectedShoe);
  }

}
